import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { fetchStripeConnection, refreshStripeConnection, startStripeConnection } from '@api/payments';

export function useStripeConnection() {
  return useQuery({
    queryKey: ['payments', 'stripe', 'connection'],
    queryFn: fetchStripeConnection,
  });
}

export function useStartStripeConnection() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: startStripeConnection,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['payments', 'stripe', 'connection'] });
    },
  });
}

export function useRefreshStripeConnection() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: refreshStripeConnection,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['payments', 'stripe', 'connection'] });
    },
  });
}
